var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3743 20.179H16.205L16.2061 12.7385C16.1229 11.0779 15.4796 9.9432 13.6408 10.1687C11.9866 10.3713 11.6376 11.7543 11.5684 13.2062L11.5695 20.179H7.42773V6.85417L7.46892 6.81288H11.3639L11.4051 6.85417V8.65567L11.4894 8.6386C12.0179 7.62058 13.1008 6.89381 14.2026 6.63394C15.437 6.34268 17.2003 6.4996 18.2983 7.17571C19.9635 8.20116 20.2776 10.2411 20.3759 12.0508L20.3745 20.179H20.3743Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84935 20.179H0.707275V6.81287H4.80817L4.84935 6.85416V20.179Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4846 0.19298C4.487 -0.011285 5.89387 2.10569 4.84393 3.85131C3.94226 5.35054 1.75124 5.40807 0.77846 3.95041C-0.206951 2.47321 0.714487 0.373295 2.4846 0.19298Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.0319af45dc6f0aa0bb90b3dfac069494.svg";
export { ForwardRef as ReactComponent };